// Helper component for the Input Field (unchanged)
export const InputField = ({ id, name, type, autoComplete, placeholder, Icon, value, onChange, hasError }) => {
  
  // Base styles that are always applied
  const baseClasses = "w-full pl-10 pr-3 py-2 border bg-slate-900 text-slate-100 rounded-lg text-sm shadow-xl transition duration-300 placeholder-slate-500";
  
  // Conditional styles for normal vs. error state
  const stateClasses = hasError
    ? "border-red-600 ring-1 ring-red-600 animate-shake" // Red border, ring, and shake animation
    : "border-slate-700 focus:ring-1 focus:ring-slate-600 focus:border-slate-600 hover:border-slate-600";

  return ( 
    <div className="relative mt-1">
      {/* Icon inside the input field - Color slate-400 */}
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-slate-400">
        <Icon className="h-5 w-5" />
      </div>
      <input
        id={id}
        name={name}
        type={type}
        autoComplete={autoComplete}
        required
        // Combined base and conditional classes
        className={`${baseClasses} ${stateClasses}`}
        placeholder={placeholder}
        value={value}         // Controlled input
        onChange={onChange}   // Controlled input
      />
      {/* Subtle geometric line effect - Gradient slate-700 */}
      <div className="absolute inset-x-0 bottom-0 h-0.5 bg-gradient-to-r from-transparent via-slate-700 to-transparent opacity-0 transition-opacity duration-300 group-focus-within:opacity-100"></div>
    </div>
  );
};